import { buildRule } from '@/employees/components/Rule/utilities/builder/ruleBuilder'
export default {
  methods: {
    /**
     * @param {string} ruleReference
     * @param {string} rulePropertyEnum
     * @param {any} value
     * @returns {void}
     */
    rulePropertyValueDelete (ruleReference, rulePropertyEnum, value = null) {
      this.$root.$emit('RulePropertyValueDelete', [ruleReference, rulePropertyEnum, value])
    },
    /**
     * @param {string} ruleReference
     * @param {string} rulePropertyEnum
     * @param {ruleObject} value
     * @returns {void}
     */
    rulePropertyValueAdd (ruleReference, rulePropertyEnum, value) {
      this.$root.$emit('RulePropertyValueAdd', [ruleReference, rulePropertyEnum, value])
    },
    /**
     * @param {string} ruleReference
     * @param {string} rulePropertyEnum
     * @param {ruleObject} value
     * @returns {void}
     */
    rulePropertyValueChange (ruleReference, rulePropertyEnum, value) {
      this.$root.$emit('RulePropertyValueChange', [ruleReference, rulePropertyEnum, value])
    },
    /**
     * @param {string} ruleReference
     * @param {string} rulePropertyEnum
     * @param {string} ruleType
     * @returns {void}
     */
    searchParentAddChild (ruleReference, ruleEnum, ruleType) {
      this.$root.$emit('AddRule', [ruleReference, buildRule(ruleEnum), ruleType])
    },
    /**
     * @param {string} ruleEnum
     * @returns {ruleObject}
     */
    buildRule (ruleEnum) {
      return buildRule(ruleEnum)
    },
    /**
     * @param {string} ruleReference
     * @returns {void}
     */
    togleDisplay (ruleReference) {
      this.$store.dispatch('set_display_rule_reference', { reference: ruleReference, display: !this.displayDetails })
    },
    /**
     * @param {string} ruleReference
     * @returns {void}
     */
    hideDisplay (ruleReference) {
      this.$store.dispatch('set_display_rule_reference', { reference: ruleReference, display: false })
    },
  },
}
